<template>
	<fragment>
		<filter-sidebar v-bind:filters="filters"></filter-sidebar>

		<div class="global-container" v-if="listing.length > 0">
			<section class="cards card--list card--list-featured section bg-white" v-if="featured.length" >
				<div class="section-header">
					<h2>Featured Article</h2>
				</div>

				<summary-item v-for="(item, index) in featured" v-bind:item="item" v-bind:key="item.DetailID"></summary-item>
			</section>

			<fragment v-if="recent.length">
				<section class="cards card--list section bg-white">
					<div class="section-header">
						<h2>Recent Articles</h2>
					</div>

					<summary-item v-if="!item.Featured" v-for="(item, index) in recent" v-bind:item="item" v-bind:key="item.DetailID"></summary-item>
				</section>

				<section class="section bg-white">
					<pagination></pagination>
				</section>
			</fragment>
		</div>
		<section class="section bg-white" v-else>
			<div class="global-container align-center">
				<h2 class="not-found-heading">Sorry, no items were found matching your specifications.</h2>
				<p>
					Try removing some filters or searching a different term.
				</p>
			</div>
		</section>
	</fragment>
</template>

<script>
	import { mapState, mapActions, mapMutations } from 'vuex';
	import Pagination from '../components/listing/pagination-dropdown';
	import SummaryItem from '../components/listing/summary-item';
	import FilterSidebar from '../components/listing/filter-sidebar';
	import blogfilter from '../filters/blog-filter';

	export default {
		props: ['filterid', 'filtertype', 'result', 'resource'],
		data: function () {
			return {
				filters: {},
				featured: [],
				recent: []
			}
		},
		computed: mapState({
			loading: state => state.listing.loading,
			listing: state => state.listing.listing,
			pagination: state => state.listing.pagination,
		}),
		watch: {
			listing(newValue, oldValue) {
				this.featured = [];
				this.recent = [];
				
				for (var i = 0; i < newValue.length; i++) {
					if (newValue[i].Featured) {
						this.featured.push(newValue[i]);
					}
					else {
						this.recent.push(newValue[i]);
					}
				}
			},
		},
		components: {
			pagination: Pagination,
			'summary-item': SummaryItem,
			'filter-sidebar': FilterSidebar
		},
		mounted: function () {
			let _this = this;

			// take props and send to vuex store
			this.setInitData(this.result);
			this.setResource(this.resource);

			// import correct filters for this view based on prop value
			if (this.filtertype === 'blogFilter') {
				this.filters = blogfilter;
			};

			this.$store.subscribeAction((action, state) => {
				if (action.type === 'listing/setFilter') {
					$('html, body').animate({
						scrollTop: $('.filter-app').offset().top
					}, 1000);
				}
			})

			// if each spec change should trigger a new api call, use this. else manually call setFilter action on button click
			this.$store.subscribe((mutation, state) => {
				if (mutation.type === 'listing/updateSpecification') {
					this.setFilter();
				}
			});
		},
		methods: {
			...mapActions('listing', { setFilter: 'setFilter' }),
			...mapMutations('listing', { setInitData: 'setInitData' }),
			...mapMutations('listing', { setResource: 'setResource' }),
        },
    }
</script>